import { GetServerSideProps } from 'next';
import React from 'react';
import ContactComponent from '../components/Contact/ContactComponent';
import Layout from '../components/Layout/Layout';
import { apiRequest } from '../components/util/requests/requests';
import { PageMetadata } from '../components/util/SeoMetaInformationComponent/SeoMetaInformationComponent';

export interface ContactProps {
    pageMetadata?: PageMetadata;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const pageMetadata = await apiRequest('/meta-pages?filters[key]=CONTACT_PAGE&populate[0]=seo');

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
        },
    };
};

const Contact = ({ pageMetadata }: ContactProps) => {
    return (
        <Layout seoMetadata={pageMetadata?.seo} defaultMetaTitle={'Noria.no - Contact'}>
            <ContactComponent extraStyles={{ padding: '110px 10% 80px', maxWidth: '1400px' }} />
        </Layout>
    );
};

export default Contact;
